import script from "./BattleIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./BattleIndex.vue?vue&type=script&setup=true&lang=js"

import "./BattleIndex.vue?vue&type=style&index=0&id=b304e3d6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b304e3d6"]])

export default __exports__